import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5021dx08mu: FaireBrandEntity = {
  token: "b_5021dx08mu",
  type: "brand",
  name: "Valley Fudge & Candy",
  avatarUrl:
    "https://cdn.faire.com/fastly/d2801c134f1a59d3f6769f67f405cd57e21121eb89b7ab0a476b840d58864eae.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6cb8b99caad5bb715a4ee4f0b04f8bb5359436ab98ddbd369bbda21cd10d153b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d2801c134f1a59d3f6769f67f405cd57e21121eb89b7ab0a476b840d58864eae.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6cb8b99caad5bb715a4ee4f0b04f8bb5359436ab98ddbd369bbda21cd10d153b.jpeg",
  location: "COON VALLEY, WI, USA",
  minimumOrderDollars: 132,
  rating: 5,
  reviewCount: 840,
  isTopShop: true,
  isInsider: true,
  description:
    "Linda's delicious fudge came about almost accidentally when she wanted to participate in a local craft show.  What could she make?  Well, long story short, her creamy, mouth-watering fudge was a BIG HIT, and she and her team have been stirring it up batch by batch ever since!  Using only top-quality, local Wisconsin butter, Valley Fudge & Candy has become the favorite of fudge-lovers around the country!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:47.741Z",
    importedBy: "entity-db-cli",
  },
};
